export default __webpack_public_path__ + "static/media/food-plate.7b8c76b7.png";